export const getLocation = ():Location => window.location;